import React, { useState, useRef, useEffect } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Select from "@mui/material/Select";
import Paper from "@mui/material/Paper";
import MenuItem from "@mui/material/MenuItem";
import Input from "@mui/material/Input";
import { PRIMARY_LIGHT_BLUE, PINK_RED, WHITE } from "../colors";
import CircularProgress from "@mui/material/CircularProgress";
import HeightBox from "../components/HeightBox";
import EmployeeProfileImage from "../components/uploads/EmployeeProfileImage";
import EmployeeService from "../services/employeeService";
import { Autocomplete, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DepartmentService from "../services/departmentService";
import DesignationService from "../services/designationService";
import TextField from "@mui/material/TextField";

const CustomSelect = styled(Select)(({ theme }) => ({
  height: 42,
  minWidth: 250,
  backgroundColor: WHITE,
  boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.05)",
  outline: "none",
  borderRadius: 10,
  border: "0px solid #fff",
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover": {
    border: "0px solid #484850",
  },
  "&:focus-within": {
    border: "0px solid #484850",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
}));

const CustomTextField = styled(Input)(({ theme }) => ({
  width: 540,
  height: 30,
  borderRadius: 4,
  backgroundColor: "#E1DEDE",
  paddingLeft: 10,
}));

const CustomInput = styled(TextField)(({ theme }) => ({
  backgroundColor: "#E1DEDE",
  borderRadius: 4,
  border: "0px solid #fff",
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover": {
    border: "0px solid #484850",
  },
  "&:focus-within": {
    border: "0px solid #484850",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
}));

const CustomAutoComplete = styled(Autocomplete)(({ theme }) => ({
  width: 540,
  height: 30,
  backgroundColor: "#E1DEDE",
  paddingLeft: 10,
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover": {
    border: "0px solid #484850",
  },
  "&:focus-within": {
    border: "0px solid #484850",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
}));

const CustomPaper = styled(Paper)(({ theme }) => ({
  backgroundColor: WHITE,
  paddingLeft: 15,
  paddingRight: 15,
  textAlign: "left",
  paddingTop: 20,
  paddingBottom: 20,
}));

const style = {
  position: "absolute",
  top: "5%",
  left: "12%",
  transform: "scale(0.8)",
  width: 1150,
  height: "100vh",
  overflowY: "scroll",
  maxHeight: 820,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  bgcolor: "#E1DEDE",
  boxShadow: 24,
  borderRadius:4,
  p: 4,
};

const CustomButton = styled(Button)(({ theme }) => ({
  height: 40,
  minWidth: 200,
  fontSize: 18,
  fontWeight: 700,
  borderRadius: 10,

  color: WHITE,
}));

export const AddNewEmployeeContainerModel = (props) => {
  const { setOpenAddNewEmployeeModel, cancelFunction, openModel, handleCancelModel } = props;

  const handleUserRoleChange = (event) => {
    setFormData({ ...formData, role: event.target.value });
  };

  const [formInfo, setFormInfo] = useState({
    departments: [],
    designations: [],
  });

  const [formData, setFormData] = React.useState({
    name: "",
    phone: "",
    dob: "",
    note: "",
    role: null,
    address: "",
    employeePhoto: null,
    joinedDate: "",
    designation: "",
    department: "",
    //onlyForUI
    depLabel: "",
    desLabel: "",
  });
  const [displayImage, setDisplayImage] = useState(null);
  const [loading, setLoading] = useState(false);

  const selectEmployeePhoto = (file) => {
    if (file) {
      const objectUrl = window.URL.createObjectURL(file);
      setDisplayImage(objectUrl);
      setFormData({
        ...formData,
        employeePhoto: file,
      });
    }
  };

  const createEmployee = async () => {
    setLoading(true);
    var bodyFormData = new FormData();
    bodyFormData.set("name", formData.name);
    bodyFormData.set("phone", formData.phone);
    bodyFormData.set("dob", formData.dob);
    bodyFormData.set("note", formData.note);
    if (formData.role !== null) bodyFormData.set("role", formData.role);
    bodyFormData.set("address", formData.address);
    bodyFormData.set("employeePhoto", formData.employeePhoto);

    await EmployeeService.createEmployee(bodyFormData).then((res) => {
      if (res.status === 201) {
        const message = "Employee created successfully";
        setLoading(false);
      } else {
        // message = res.message;
        alert("Employee creation failed please recheck all the fields and try again (check image)");
        setLoading(false);
      }
    });


  };

  useEffect(() => {
    const getData = async () => {
      const deps = await DepartmentService.getAllDepartments();
      const des = await DesignationService.getAllDesignations();

      setFormInfo({
        designations: des.data.map((d) => {
          return { value: d.id, label: d.name };
        }),
        departments: deps.data.map((d) => {
          return { value: d.id, label: d.name };
        }),
      });
      setFormData({
        ...formData,
        department: deps.data[0]?.id,
        depLabel: deps.data[0]?.name,
        designation: des.data[0]?.id,
        desLabel: des.data[0]?.name,
      });
    };
    getData();
  }, []);
  return (
    <Modal
   
      open={openModel}
      onClose={handleCancelModel}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <IconButton
          aria-label="delete"
          onClick={cancelFunction}
          sx={{ position: "absolute", right: "20px", top: "20px" }}
        >
          <CloseIcon />
        </IconButton>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Add new User
        </Typography>
        {/* <IconButton onClick={handleCancelModel}>
          <CloseIcon />
        </IconButton> */}

        <HeightBox height={10} />
        <Stack direction="row" alignItems="center" spacing={5}>
          <div>
            <CustomSelect
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              onChange={handleUserRoleChange}
              defaultValue={"x"}
            >
              <MenuItem value={"x"} disabled>
                User Role(default:{props?.roles[0]?.name})
              </MenuItem>
              {props.roles?.map((role) => (
                <MenuItem key={role.id} value={role.id}>
                  {role.name}
                </MenuItem>
              ))}
            </CustomSelect>
            <HeightBox height={10} />
            <CustomPaper style={{ width: 250, textAlign: "center" }} elevation={0}>
              <HeightBox height={10} />
              <Typography fontSize={18} fontWeight={700}>
                Upload Employee Image
              </Typography>
              <HeightBox height={10} />

              <EmployeeProfileImage fileUploadHandler={selectEmployeePhoto} photo={displayImage} />
            </CustomPaper>
          </div>
          <div>
            {/* <HeightBox height={5} /> */}
            <Typography fontSize={18} fontWeight={700} textAlign="left">
              Personal Details
            </Typography>
            <HeightBox height={10} />
            <CustomPaper elevation={0}>
              <Stack direction="row"  spacing={2}>
                <div>
                  <Typography  fontSize={18}>User Name :</Typography>
                  <HeightBox height={14} />
                  <Typography fontSize={18}>Birthday :</Typography>
                  <HeightBox height={14} />
                  <Typography fontSize={18}>Address :</Typography>
                  <HeightBox height={14} />
                  <Typography fontSize={18}>Department :</Typography>
                  <HeightBox height={14} />
                  <Typography fontSize={18}>Designation :</Typography>
                  <HeightBox height={14} />
                  <Typography fontSize={18}>Joined Date :</Typography>
                  <HeightBox height={14} />
                  <Typography fontSize={18}>Phone :</Typography>
                  <HeightBox height={14} />
                  <Typography fontSize={18}>Note :</Typography>
                </div>
                <div>
                  <CustomTextField
                    disableUnderline
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  />
                  <HeightBox height={10} />
                  <CustomTextField
                    type="date"
                    disableUnderline
                    value={formData.dob}
                    onChange={(e) => setFormData({ ...formData, dob: e.target.value })}
                  />
                  <HeightBox height={10} />
                  <CustomTextField
                    disableUnderline
                    value={formData.address}
                    onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                  />
                  <HeightBox height={10} />
                  <Autocomplete
                    disablePortal
                    sx={{ minWidth: 200 }}
                    size="small"
                    onChange={(event, value) => {
                      setFormData({
                        ...formData,
                        department: value?.value,
                        depLabel: value?.label,
                      });
                    }}
                    value={formData.depLabel}
                    id="combo-box-demo"
                    options={formInfo?.departments}
                    renderInput={(params) => <CustomInput {...params} />}
                  />
                  <HeightBox height={10} />
                  <Autocomplete
                    sx={{ minWidth: 200 }}
                    size="small"
                    disablePortal
                    onChange={(event, value) => {
                      setFormData({
                        ...formData,
                        designation: value?.value,
                        desLabel: value?.label,
                      });
                    }}
                    value={formData.desLabel}
                    id="combo-box-demo"
                    options={formInfo.designations}
                    renderInput={(params) => <CustomInput {...params} />}
                  />
                  <HeightBox height={10} />
                  <CustomTextField
                    type="date"
                    disableUnderline
                    value={formData.joinedDate}
                    onChange={(e) => setFormData({ ...formData, joinedDate: e.target.value })}
                  />
                  <HeightBox height={10} />
                  <CustomTextField
                    disableUnderline
                    value={formData.phone}
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  />
                  <HeightBox height={10} disableUnderline />
                  <CustomTextField
                    disableUnderline
                    rows={3}
                    value={formData.note}
                    onChange={(e) => setFormData({ ...formData, note: e.target.value })}
                  />
                </div>
              </Stack>
            </CustomPaper>
          </div>
        </Stack>
        <HeightBox height={40} />
        {/* <CustomPaper
          elevation={0}
          style={{
            width: 950,
            textAlign: "center",
            paddingTop: 40,
            paddingBottom: 40,
            marginTop: 20,
          }}
        >
          <Typography fontSize={18} fontWeight={700}>
            Upload Employee Documents
          </Typography>
          <HeightBox height={20} />
          <Typography fontSize={18}>Birth Certificates, Agreenents..... you can upload PDF files.</Typography>
        </CustomPaper> */}
        <HeightBox height={30} />
        <Stack
          style={{
            marginTop: 20,
          }}
          direction="row"
          alignItems="center"
          spacing={3}
        >
          <CustomButton style={{ backgroundColor: PINK_RED }} onClick={cancelFunction}>
            Cancel
          </CustomButton>
          <CustomButton style={{ backgroundColor: PRIMARY_LIGHT_BLUE }} onClick={createEmployee} >
            {loading ? <CircularProgress size={15} /> : " Create Employee"}
          </CustomButton>
        </Stack>
      </Box>
    </Modal>
  );
};
